import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import SecurityGroupForm from '../SecurityGroupForm';
import { Modes, Statuses } from '../../../constants/Enums';
import {
    fetchSecurityGroup,
    patchSecurityGroup,
    putSecurityGroupApps,
    putSecurityGroupPermissions,
    putSecurityGroupUsers
} from '../../../api/SecurityGroupApi';
import { addApp, removeApp, toggleSecurityModal, updateSecurityGroup } from '../../../actions/SecurityGroupActions';
import { bindActionCreators } from 'redux';
import Routes from '../../../constants/Routes';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';

import { overlayDivStyles } from '../../common/styles/LoadingOverlay.css';

class UpdateSecurityGroupForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            landingFlag: false,
            securityGroup: {},
            showConfirmModal: false,
            showConflictModal: false,
            showNoRosterOfficesModal: false,
            error: {},
            showError: false,
            formErrors: [],
            errorMessage: 'An unknown  error has occurred',
            roleType: null,
            securityGroupUpdateStatus: Statuses.NOT_STARTED,
            permissionUpdateStatus: Statuses.NOT_STARTED,
            appUpdateStatus: Statuses.NOT_STARTED,
            usersUpdateStatus: Statuses.NOT_STARTED,
            activeApps: {},
            lastRemaining: false,
            lastRemainingModal: false
        };
    }

    setConfirmModalOpen = isOpen => {
        this.setState({ showConfirmModal: isOpen });
    };

    setConflictModalOpen = isOpen => {
        this.setState({ showConflictModal: isOpen });
    };

    setNoRosterOfficesModalOpen = isOpen => {
        this.setState({ showNoRosterOfficesModal: isOpen });
    };

    setLastRemainingModalOpen = isOpen => {
        this.setState({ showLastRemainingModal: isOpen });
        !isOpen && this.setBothModalOpen(false);
    };

    setBothModalOpen = (isOpen) => {
        this.setConflictModalOpen(isOpen);
        this.setConfirmModalOpen(isOpen);
    };

    setApps = (appId) => {
        let securityGroup = this.state.securityGroup;
        if (securityGroup.appIds && securityGroup.appIds.includes(appId)) {
            this.props.removeApp(appId);
            this.props.updateSecurityGroup(securityGroup);
        } else {
            this.props.addApp(appId);
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.props.securityGroup.permissions['R-U'] === undefined && this.state.lastRemaining) {
            this.setLastRemainingModalOpen(true)
        }

        const scopedPermissionsWithZeroOffices = Object.keys(this.state.securityGroup.permissions)
            .reduce((prevVal, currentVal) => {
                if (this.state.securityGroup.permissions[currentVal]?.scopeId === 2
                    && this.state.securityGroup.permissions[currentVal].officeIds?.length === 0) {
                        prevVal++;
                    }
                return prevVal;
            }, 0);

        if (scopedPermissionsWithZeroOffices > 0) {
            return this.setNoRosterOfficesModalOpen(true);
        }

        for (let x = 0; x < this.state.securityGroup.users.length; x++) {
            if (this.state.securityGroup.users[x].userId === this.props.user.lwt.uid) {
                if (this.state.securityGroup.permissions['R-U'] === undefined
                    || this.state.securityGroup.permissions['R-U'] === null) {
                    this.setConflictModalOpen(true);
                    break;
                }
            }
        }

        this.setConfirmModalOpen(true);
    };

    submitForm = () => {
        this.updateNameAndDescription();
        if (this.state.showConflictModal) {
            this.setState({ landingFlag: true });
            this.setConflictModalOpen(false);
        } else {
            this.setConfirmModalOpen(false);
        }
    };

    handleSecurityGroupUpdateComplete(updateStatus) {
        if (updateStatus === Statuses.SUCCESS) {
            this.updatePermissions();
        }
    }

    handlePermissionsUpdateComplete = (permissionUpdateStatus) => {
        //If permission update was successful,
        //Update users
        if (permissionUpdateStatus === Statuses.SUCCESS) {
            this.updateUsers();
        }
    };

    handleUsersUpdateComplete = (usersUpdateStatus) => {
        //If users update successful, update apps in group
        if (usersUpdateStatus === Statuses.SUCCESS)
            this.updateApps();
    };

    updateNameAndDescription = () => {
        let { name, description, version, id } = this.state.securityGroup;
        let patchRequest = {
            name, description, version, id
        };
        this.props.patchSecurityGroup(patchRequest);
    };

    updatePermissions = () => {
        let { permissions, version, id } = this.state.securityGroup;
        let putPermissionsRequest = {
            permissions,
            id,
            version
        };
        this.props.putSecurityGroupPermissions(putPermissionsRequest);
    };

    updateUsers = () => {
        let { users, id, version } = this.state.securityGroup;
        let putUsersRequest = {
            users,
            id,
            version
        };
        this.props.putSecurityGroupUsers(putUsersRequest);
    };

    updateApps = () => {
        let { appIds, id, version } = this.state.securityGroup;
        let putAppsRequest = {
            appIds,
            id,
            version
        };
        this.props.putSecurityGroupApps(putAppsRequest);
    };

    handleAppsUpdateComplete = (appUpdateStatus) => {
        if (appUpdateStatus === Statuses.SUCCESS) {
            if (this.state.landingFlag) {
                this.props.history.push(Routes.LANDING_PAGE);
                this.setState({ landingFlag: false })
            } else {
                this.props.history.push(Routes.SECURITY_GROUPS);
            }
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.securityGroup && nextProps.securityGroup !== this.state.securityGroup) {
            this.setState({
                securityGroup: nextProps.securityGroup,
                roleType: nextProps.securityGroup.roleType
            });
        }
        if (nextProps.activeApps !== this.state.activeApps) {
            this.setState({ activeApps: { ...nextProps.activeApps } });
        }
        if (nextProps.form && nextProps.form.syncErrors !== this.state.formErrors) {
            this.setState({ formErrors: nextProps.form.syncErrors });
        }
        if (nextProps.showError !== this.state.showError) {
            this.setState({ showError: nextProps.showError });
        }
        if (nextProps.securityGroupUpdateStatus !== this.state.securityGroupUpdateStatus) {
            this.setState({ securityGroupUpdateStatus: nextProps.securityGroupUpdateStatus });
        }
        if (nextProps.permissionUpdateStatus !== this.state.permissionUpdateStatus) {
            this.setState({ permissionUpdateStatus: nextProps.permissionUpdateStatus });
        }
        if (nextProps.appUpdateStatus !== this.state.appUpdateStatus) {
            this.setState({ appUpdateStatus: nextProps.appUpdateStatus });
        }
        if (nextProps.usersUpdateStatus !== this.state.usersUpdateStatus) {
            this.setState({ usersUpdateStatus: nextProps.usersUpdateStatus });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let {
            appUpdateStatus,
            usersUpdateStatus,
            permissionUpdateStatus,
            securityGroupUpdateStatus
        } = prevState;

        if (this.props.securityGroup !== prevProps.securityGroup && prevProps.securityGroup.id === undefined) {
            this.setState({
                lastRemaining: (this.props?.securityGroup?.permissions?.['R-U'] && (this.props?.securityGroups ?? [])
                    .filter(group => group?.permissions?.['R-U']).length < 2)
            });
        }
        if (securityGroupUpdateStatus !== this.state.securityGroupUpdateStatus) {
            this.handleSecurityGroupUpdateComplete(this.state.securityGroupUpdateStatus);
        }
        if (permissionUpdateStatus !== this.state.permissionUpdateStatus) {
            this.handlePermissionsUpdateComplete(this.state.permissionUpdateStatus);
        }
        if (usersUpdateStatus !== this.state.usersUpdateStatus) {
            this.handleUsersUpdateComplete(this.state.usersUpdateStatus);
        }
        if (appUpdateStatus !== this.state.appUpdateStatus) {
            this.handleAppsUpdateComplete(this.state.appUpdateStatus);
        }
    }

    render() {
        if (this.props.securityGroup
            && this.props.securityGroup.id
            && this.props.users
            && this.props.apps
            && this.props.permissions
        ) {
            return (
                <SecurityGroupForm toggleSecurityModal={this.props.toggleSecurityModal}
                    isFetching={this.props.isFetching}
                    showError={this.state.showError}
                    mode={Modes.EDIT} apps={this.props.apps}
                    setConfirmModalOpen={this.setConfirmModalOpen}
                    submitForm={this.submitForm}
                    showConfirmModal={this.state.showConfirmModal}
                    showConflictModal={this.state.showConflictModal}
                    showNoRosterOfficesModal={this.state.showNoRosterOfficesModal}
                    setNoRosterOfficesModalOpen={this.setNoRosterOfficesModalOpen}
                    showLastRemainingModal={this.state.showLastRemainingModal}
                    setConflictModalOpen={this.setConflictModalOpen}
                    setBothModalOpen={this.setBothModalOpen}
                    setLastRemainingModalOpen={this.setLastRemainingModalOpen}
                    securityGroup={this.state.securityGroup}
                    handleSubmit={this.handleSubmit}
                    errorMessage={this.props.errorMessage}
                    buttonIsDisabled={() => {
                        return this.state.formErrors != null;
                    }}
                    cancel={() => this.props.redirect(Routes.SECURITY_GROUPS)}
                    permissions={this.props.permissions}
                    isModalOpen={this.props.isModalOpen}
                    disabled={false} roleType={this.state.roleType} addApp={this.setApps}
                    removeApp={this.setApps}
                />
            );
        } else return (
            <div className={'content'} style={overlayDivStyles}>
                <LoadingOverlay loading={true}>

                </LoadingOverlay>
            </div>
        )
    }
}

UpdateSecurityGroupForm.propTypes = {
    redirect: PropTypes.func.isRequired,
    toggleSecurityModal: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool,
    roleId: PropTypes.string.isRequired,
    setErrorMessage: PropTypes.func,
    showError: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    form: PropTypes.object,
    permissions: PropTypes.array,
    securityGroup: PropTypes.object,
    securityGroups: PropTypes.array,
    users: PropTypes.array,
    apps: PropTypes.array,
    isFetching: PropTypes.bool,
    activeApps: PropTypes.object,
    securityGroupUpdateStatus: PropTypes.number,
    permissionUpdateStatus: PropTypes.number,
    appUpdateStatus: PropTypes.number,
    usersUpdateStatus: PropTypes.number,
    removeApp: PropTypes.func,
    updateSecurityGroup: PropTypes.func,
    addApp: PropTypes.func,
    user: PropTypes.object,
    patchSecurityGroup: PropTypes.func,
    putSecurityGroupPermissions: PropTypes.func,
    putSecurityGroupUsers: PropTypes.func,
    putSecurityGroupApps: PropTypes.func,
    history: PropTypes.object,
    permission: PropTypes.object
};

function mapStateToProps(state) {
    return {
        form: state.form.createSecurityGroup,
        permissions: state.securityGroup.permissions,
        securityGroup: state.securityGroup.securityGroup,
        securityGroups: state.securityGroup.securityGroups,
        isModalOpen: state.securityGroup.isModalOpen,
        users: state.authenticationReducer.users,
        apps: state.securityGroup.apps,
        isFetching: state.securityGroup.isFetching,
        activeApps: state.securityGroup.activeApps,
        securityGroupUpdateStatus: state.securityGroup.securityGroupUpdateStatus,
        permissionUpdateStatus: state.securityGroup.permissionUpdateStatus,
        appUpdateStatus: state.securityGroup.appUpdateStatus,
        usersUpdateStatus: state.securityGroup.usersUpdateStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSecurityModal, fetchSecurityGroup, patchSecurityGroup,
        putSecurityGroupApps, putSecurityGroupPermissions, putSecurityGroupUsers,
        addApp, removeApp, updateSecurityGroup
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpdateSecurityGroupForm));
